import { Steps } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface PayoutStep {
  title: string;
  path: string;
}

interface PayoutCheckoutStepsProps {
  activeStep: number;
}

// Export step paths for navigation (without translations)
export const payoutStepPaths = [{ path: 'review' }, { path: 'processing' }];

// Helper function to get translated steps
export const getPayoutSteps = (t: (key: string) => string): PayoutStep[] => [
  { title: t('payouts.checkout.steps.reviewAndPay'), path: 'review' },
  { title: t('payouts.checkout.steps.payment'), path: 'processing' },
];

export const PayoutCheckoutSteps: React.FC<PayoutCheckoutStepsProps> = ({ activeStep }) => {
  const { t } = useTranslation();
  const payoutSteps = getPayoutSteps(t);

  return (
    <Steps.Root
      size="sm"
      step={activeStep}
      count={payoutSteps.length}
      colorPalette="primary"
      variant="subtle"
      maxW="500px"
    >
      <Steps.List>
        {payoutSteps.map((step: PayoutStep, index: number) => (
          <Steps.Item key={index} index={index}>
            <Steps.Indicator
              bg={index === activeStep ? 'primary.fg' : 'primary.200'}
              fontSize="14px"
              color={index === activeStep ? 'white' : 'default'}
            />
            <Steps.Title color={index === activeStep ? 'primary.500' : 'default'} fontSize="16px">
              {step.title}
            </Steps.Title>
            <Steps.Separator />
          </Steps.Item>
        ))}
      </Steps.List>
    </Steps.Root>
  );
};
